
import { Component, Vue } from 'vue-property-decorator';
import { generateUID } from 'ah-common-lib/src/helpers/uuid';

@Component
export default class NeedHelpButton extends Vue {
  private uid = generateUID(6);

  get helpLink() {
    return this.$theme.val?.helpURL;
  }

  get helpEmail() {
    return this.$theme.val?.helpEmail;
  }

  goToHelpLink() {
    window.open(this.helpLink, '_blank');
  }
}
